import { firstOrDefault } from '~/utils/arrays';

const notUndefined = (x) => x !== undefined;

export function openPopup(url, title, popupWidth, popupHeight) {
  const dualScreenLeft = firstOrDefault(
    [window.screenLeft, window.screenX],
    notUndefined
  );

  const dualScreenTop = firstOrDefault(
    [window.screenTop, window.screenY],
    notUndefined
  );

  const width = firstOrDefault(
    [window.innerWidth, document.documentElement.clientWidth],
    notUndefined
  );
  const height = firstOrDefault(
    [window.innerHeight, document.documentElement.clientHeight],
    notUndefined
  );

  const left = width / 2 - popupWidth / 2 + dualScreenLeft;
  const top = height / 2 - popupHeight / 2 + dualScreenTop;

  // window.open() expects a comma-separated feature list (e.g.
  // "scrollbars=yes,width=800,..."), so join key=value pairs with ','.
  const options = Object.entries({
    scrollbars: 'yes',
    width: popupWidth,
    height: popupHeight,
    top,
    left
  })
    .map(([key, value]) => `${key}=${value}`)
    .join(',');

  const newWindow = window.open(url, title, options);

  if (newWindow && newWindow.focus) {
    newWindow.focus();
  }

  return newWindow;
}
